<template>
  <div id="app">
    <!-- navbar begin -->
    <div class="no-print" uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky">
        <nav class="uk-navbar-container" id="grad" style="background-color:#009688;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);" uk-navbar="dropbar: true;">

                <div class="uk-navbar-left">
            
                    <ul class="uk-navbar-nav" >
                        <li>
                            <a href="#"><span class="uk-icon-link uk-margin-small-right uk-margin-small-left active" uk-icon='icon: menu; ratio: 1.6' style="color:white;"></span></a>
                            
                            <div class="uk-navbar-dropdown">
                                <ul class="uk-nav uk-navbar-dropdown-nav">
                                    <li><router-link :to="'/'">Home</router-link></li>
                                    <li class="uk-nav-divider"></li>
                                </ul>
                            </div>
                        </li>
                        <!-- <li class="uk-active"><a href="#">Menu</a></li> -->
                    </ul>
            
                </div>

                <div  class="uk-navbar-center uk-light uk-margin-small">
                   <!-- <router-link :to="'/'" > <h2> <span > 5c </span></h2></router-link> -->
                   <h2> <span >SCORING 7c </span></h2>
                </div>

        </nav>
        <div class="uk-navbar-dropbar"></div>
    </div>
    <!-- navbar end -->

    <router-view @login="showModal" class="uk-container"/>

    <hr class="uk-margin-medium-top">

      <!-- footer -->
    
      <div class=" uk-margin uk-padding uk-text-center" uk-grid>
        <div>
          <p>Scoring Desarrollado por Integral Consulting</p>
        </div>
        <!-- <div>      
          <p><a  class="uk-text-link uk-link-text" href="mailto:midoctmpn@gmail.com">Contacto por correo a midoctmpn@gmail.com</a></p>
        </div>
        <div>      
          <p><a  class="uk-text-link uk-link-text" href="https://wa.me/5215580138994">Contacto en México al +52-1-55-8013-8994</a></p>
        </div>
        <div>      
          <p><a  class="uk-text-link uk-link-text" href="https://wa.me/593992659214">Contacto en Ecuador al +593-992659214</a></p>
        </div>
        <div>      
          <p class="uk-text-link uk-link-text" >Oficina Matriz: Fray Angelico, colonia Nonoalco, Ciudad de México</p>
        </div> -->
      </div>



          
<div id="modal-example" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Ingresa tu código de empresa:</h2>
        <form id="form">
          <div class="uk-margin">
            <input type="password" v-model="pass" class="uk-input " placeholder="Código de empresa" required>
          </div>
          <div class="uk-margin">
            <label><input class="uk-checkbox" type="checkbox" required> He leido y acepto los <a class="uk-link-text uk-text-primary" href="https://verificagps-89c24.firebaseapp.com/privpol.html">términos y condiciones</a></label>
          </div>
          <p v-if="!loading" class="uk-text-right">
              <button class="uk-button uk-button-default uk-modal-close " type="button">Cancelar</button>
              <button class="uk-button uk-button-primary" type="submit">Continuar</button>
          </p>
          <p v-else class="uk-text-center">
            <span uk-spinner="ratio:2"></span>
          </p>
        </form>
        <p style="color:darkred">Deberás volver a dar click al botón para ver tus resultados</p>
    </div>
</div>


  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* nav {
  padding: 30px;
} */

nav a {
  font-weight: bold;
  color: #2c3e50;
}

.uk-button-primary {
  background-color: #009688;
}

hr{
  height:1px;
  border:none;
  background-color: #009688;
}
.print-only{
  display: none;
}
@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
        padding: 0%;
    }
    .print-only{
      display: block;
    }
    
    #nav {
      padding: 0px;
    }
    h1 {
      padding: 0px;
    }
    h3 {
      padding: 0px;
    }
}
</style>

<script>
export default {
  data:function(){
    return {
      pass : '',
      loading : false,
    }
  },
  mounted:function(){
  }, 
  methods:{
    showModal : showModal,
    onContinue : onContinue
  }
}


function showModal( ) {
    UIkit.modal(document.getElementById('modal-example')).show() 
}

function onContinue() {
  timer.start({precision: 'seconds'})
  this.$router.push('1c')
}
</script>
